import inherited from 'mastodon/locales/it.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
